import { ID, Task, TaskActionType } from '@griply/types';

// Replaces goal.taskCount, which drifts — it is maintained by increment(±1).
export const buildGoalOpenTaskCounts = (tasks: Task[]): Map<ID, number> => {
  const counts = new Map<ID, number>();

  tasks.forEach((task) => {
    if (!task.goalId || task.completedAt || task.archivedAt) {
      return;
    }

    if (task.action?.type === TaskActionType.GoalTimeslot) {
      return;
    }

    counts.set(task.goalId, (counts.get(task.goalId) ?? 0) + 1);
  });

  return counts;
};
